// src/pages/Contact.js
import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';
import { Helmet } from 'react-helmet';

const Contact = () => {
  const [notification, setNotification] = useState('');
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Function to copy text to clipboard and show the notification at cursor location
  const copyToClipboard = (text, event) => {
    navigator.clipboard.writeText(text).then(() => {
      setNotification(`${text} copied to clipboard!`);
      setPosition({ x: event.clientX, y: event.clientY }); // Set cursor position
      setTimeout(() => {
        setNotification(''); // Hide notification after 3 seconds
      }, 3000);
    });
  };

  return (
    <div>
      <Helmet>
        {/* Primary SEO Meta Tags */}
        <title>Nordic Numbers | Causal Analysis for Business Insights</title>
        <meta
          name="description"
          content="Nordic Numbers provides cutting-edge causal analysis to help businesses understand not just what might happen, but why. If you understand why, you can purposefully induce the results you desire."
        />
        <meta
          name="keywords"
          content="causal analysis, business insights, data analytics, machine learning, predictive analysis, data-driven decisions"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Nordic Numbers | Causal Analysis for Business Insights" />
        <meta
          property="og:description"
          content="We help businesses use causal analysis to make data-driven decisions that not only predict outcomes but explain why they happen."
        />
        <meta property="og:image" content="https://www.nordicnumbers.no/bigger_logo.png" />
        <meta property="og:url" content="https://www.nordicnumbers.no" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Nordic Numbers | Causal Analysis and Data-Driven Insights" />
        <meta
          name="twitter:description"
          content="At Nordic Numbers, we use causal analysis to help businesses make informed, data-driven decisions. Understand not just what might happen, but why."
        />
        <meta name="twitter:image" content="https://www.nordicnumbers.no/bigger_logo.png" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Nordic Numbers",
              "url": "https://www.nordicnumbers.no",
              "logo": "https://www.nordicnumbers.no/small_logo.png",
              "description": "Nordic Numbers provides causal data analysis services, helping businesses understand not just what might happen but why.",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+47 948 24 472",
                "email": "jone@nordicnumbers.no",
                "contactType": "Customer Service"
              },
              "sameAs": [
                "https://www.linkedin.com/company/nordic-numbers/"
              ]
            }
          `}
        </script>
      </Helmet>
      <Navbar />
      <div className="contact-container">
        <div className="contact-box" onClick={(e) => copyToClipboard('+47 948 24 472', e)}>
          <img src="contact_icon_1.png" alt="Phone Icon" className="contact-icon" />
          <div className="contact-info">
            <h2>Phone Number</h2>
            <p>+47 948 24 472</p>
          </div>
        </div>
        <div className="contact-box" onClick={(e) => copyToClipboard('jone@nordicnumbers.no', e)}>
          <img src="contact_icon_2.png" alt="Email Icon" className="contact-icon" />
          <div className="contact-info">
            <h2>Email</h2>
            <p>jone@nordicnumbers.no</p>
          </div>
        </div>
        <a
          href="https://www.linkedin.com/company/nordic-numbers/"
          className="contact-box"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="contact_icon_3.png" alt="LinkedIn" className="contact-icon" />
          <div className="contact-info">
            <h2>LinkedIn</h2>
            <p>https://www.linkedin.com/company/nordic-numbers/</p>
          </div>
        </a>
      </div>

      {/* Notification Element */}
      {notification && (
        <div
          className="copy-notification"
          style={{ top: `${position.y}px`, left: `${position.x}px` }}
        >
          {notification}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Contact;
